import {
  GetWebApiDocGlossaryById,
  GetWebApiDocumentById,
  GetWebApiDocuments,
  GetWebApiDocumentsByTitle,
  GetWebApiSectionsByTitle,
  GetWebApiGlossaryByTitle,
  GetWebApiSearch,
  GetWebApiGetRelatedSectionsId,
  GetWebApiRelateDocsById,
  GetWebApiSectionByDocId,
  GetWebApiSectionsById,
  GetWebApiSummaryByDocId,
  QueryWebApiDocuments,
  GetWebApiMyQueries,
  CompareWebApiDocuments,
  GetWebApiRelatedContentByDoc,
  GetWebApiRelatedContentByTaxonomyItem,
  GetWebApiTaxonomies,
  GetWebApiTaxonomyItems,
  GetWebApiTaxonomyItem,
  GetWebApiTaxonomyItemDocuments,
} from '../../services/webApiAxios';
import {
  WEB_API_GET_DOCUMENTS,
  WEB_API_GET_DOCUMENT_BY_ID,
  WEB_API_GET_RELATED_DOCS_BY_ID,
  WEB_API_GET_RELATED_SECTION_BY_ID,
  WEB_API_GET_SECTIONS_BY_ID,
  WEB_API_GET_SECTION_BY_PAGE_ID,
  WEB_API_GET_SUMMARY_BY_DOC_ID,
  WEB_API_GET_DOC_GLOSSARY_BY_ID,
  WEB_API_LOADING,
} from './webApiTypes';

export const webApiLoading = () => ({
  type: WEB_API_LOADING,
});

export const getWebApiDocuments = (version) => {
  return async (dispatch, getState) => {
    dispatch(webApiLoading());
    const token = getState().user.user.token;
    const res = await GetWebApiDocuments(token, version);
    dispatch({ type: WEB_API_GET_DOCUMENTS, payload: res && res.data ? res.data : null });
    return res;
  };
};

export const getWebApiDocumentsByTitle = (version, title) => {
  return async (dispatch, getState) => {
    dispatch(webApiLoading());
    const token = getState().user.user.token;
    const res = await GetWebApiDocumentsByTitle(token, version, title);
    dispatch({ type: WEB_API_GET_DOCUMENTS, payload: res && res.data ? res.data : null });
    return res;
  };
};

export const getWebApiSectionsByTitle = (version, documentId, title) => {
  return async (dispatch, getState) => {
    dispatch(webApiLoading());

    const token = getState().user.user.token;

    const res = await GetWebApiSectionsByTitle(token, version, documentId, title);

    dispatch({
      type: WEB_API_GET_SECTIONS_BY_ID,
      payload: res && res.data ? res.data : null,
    });

    return res;
  };
};

export const getWebApiGlossaryByTitle = (version, title) => {
  return async (dispatch, getState) => {
    dispatch(webApiLoading());

    const token = getState().user.user.token;

    const res = await GetWebApiGlossaryByTitle(token, version, title);

    dispatch({
      type: WEB_API_GET_DOC_GLOSSARY_BY_ID,
      payload: res && res.data ? res.data : null,
    });

    return res;
  };
};

export const getWebApiSearch = (version, q) => {
  return async (dispatch, getState) => {
    dispatch(webApiLoading());

    const token = getState().user.user.token;

    const res = await GetWebApiSearch(token, version, q);

    dispatch({
      type: WEB_API_GET_SECTIONS_BY_ID,
      payload: res && res.data ? res.data : null,
    });

    return res;
  };
};

// AI query — POST { query, documentIds }. The Explorer renders the raw response
// (the NLP answer, or the API's error envelope), so mirror the search action.
export const queryWebApiDocuments = (version, body) => {
  return async (dispatch, getState) => {
    dispatch(webApiLoading());

    const token = getState().user.user.token;

    const res = await QueryWebApiDocuments(token, version, body);

    dispatch({
      type: WEB_API_GET_SECTIONS_BY_ID,
      payload: res || null,
    });

    return res;
  };
};

// AI document comparison — POST two document versions. Returns the completed comparison
// (or a comparison_id to poll). The Explorer renders the raw response.
export const compareWebApiDocuments = (version, body) => {
  return async (dispatch, getState) => {
    dispatch(webApiLoading());

    const token = getState().user.user.token;

    const res = await CompareWebApiDocuments(token, version, body);

    dispatch({
      type: WEB_API_GET_SECTIONS_BY_ID,
      payload: res || null,
    });

    return res;
  };
};

// The caller's own recent AI queries (history). Read-only, unmetered.
export const getWebApiMyQueries = (version, take) => {
  return async (dispatch, getState) => {
    dispatch(webApiLoading());

    const token = getState().user.user.token;

    const res = await GetWebApiMyQueries(token, version, take);

    dispatch({
      type: WEB_API_GET_SECTIONS_BY_ID,
      payload: res && res.data ? res.data : null,
    });

    return res;
  };
};

// Related content resolved for a document, or for a taxonomy container. Explorer renders the response.
export const getWebApiRelatedContentByDoc = (version, documentId) => {
  return async (dispatch, getState) => {
    dispatch(webApiLoading());
    const token = getState().user.user.token;
    const res = await GetWebApiRelatedContentByDoc(token, version, documentId);
    dispatch({ type: WEB_API_GET_SECTIONS_BY_ID, payload: res && res.data ? res.data : null });
    return res;
  };
};

export const getWebApiRelatedContentByTaxonomyItem = (version, taxonomy, itemId) => {
  return async (dispatch, getState) => {
    dispatch(webApiLoading());
    const token = getState().user.user.token;
    const res = await GetWebApiRelatedContentByTaxonomyItem(token, version, taxonomy, itemId);
    dispatch({ type: WEB_API_GET_SECTIONS_BY_ID, payload: res && res.data ? res.data : null });
    return res;
  };
};

// --- Taxonomies --- the Explorer renders the response, so these mirror the
// search/by-title actions: fetch, stash the payload under a generic type, return res.
export const getWebApiTaxonomies = (version) => {
  return async (dispatch, getState) => {
    dispatch(webApiLoading());
    const token = getState().user.user.token;
    const res = await GetWebApiTaxonomies(token, version);
    dispatch({ type: WEB_API_GET_SECTIONS_BY_ID, payload: res && res.data ? res.data : null });
    return res;
  };
};

export const getWebApiTaxonomyItems = (version, taxonomy) => {
  return async (dispatch, getState) => {
    dispatch(webApiLoading());
    const token = getState().user.user.token;
    const res = await GetWebApiTaxonomyItems(token, version, taxonomy);
    dispatch({ type: WEB_API_GET_SECTIONS_BY_ID, payload: res && res.data ? res.data : null });
    return res;
  };
};

export const getWebApiTaxonomyItem = (version, taxonomy, id) => {
  return async (dispatch, getState) => {
    dispatch(webApiLoading());
    const token = getState().user.user.token;
    const res = await GetWebApiTaxonomyItem(token, version, taxonomy, id);
    dispatch({ type: WEB_API_GET_SECTIONS_BY_ID, payload: res && res.data ? res.data : null });
    return res;
  };
};

export const getWebApiTaxonomyItemDocuments = (version, taxonomy, id) => {
  return async (dispatch, getState) => {
    dispatch(webApiLoading());
    const token = getState().user.user.token;
    const res = await GetWebApiTaxonomyItemDocuments(token, version, taxonomy, id);
    dispatch({ type: WEB_API_GET_DOCUMENTS, payload: res && res.data ? res.data : null });
    return res;
  };
};

export const getWebApiDocumentById = (version, id) => {
  return async (dispatch, getState) => {
    dispatch(webApiLoading());

    const token = getState().user.user.token;

    const res = await GetWebApiDocumentById(token, version, id);

    if (res && res.data) {
      const data = res.data;

      dispatch({
        type: WEB_API_GET_DOCUMENT_BY_ID,
        payload: data,
      });

      return res;
    } else {
      dispatch({
        type: WEB_API_GET_DOCUMENT_BY_ID,
        payload: null,
      });

      return res;
    }
  };
};

export const getWebApiSectionsById = (version, id) => {
  return async (dispatch, getState) => {
    dispatch(webApiLoading());

    const token = getState().user.user.token;

    const res = await GetWebApiSectionsById(token, version, id);

    if (res && res.data) {
      const data = res.data;

      dispatch({
        type: WEB_API_GET_SECTIONS_BY_ID,
        payload: data,
      });

      return res;
    } else {
      dispatch({
        type: WEB_API_GET_SECTIONS_BY_ID,
        payload: null,
      });

      return res;
    }
  };
};

export const getWebApiRelateDocsById = (version, id) => {
  return async (dispatch, getState) => {
    dispatch(webApiLoading());

    const token = getState().user.user.token;

    const res = await GetWebApiRelateDocsById(token, version, id);

    if (res && res.data) {
      const data = res.data;

      dispatch({
        type: WEB_API_GET_RELATED_DOCS_BY_ID,
        payload: data,
      });

      return res;
    } else {
      dispatch({
        type: WEB_API_GET_RELATED_DOCS_BY_ID,
        payload: null,
      });

      return res;
    }
  };
};

export const getWebApiDocGlossaryById = (version, id) => {
  return async (dispatch, getState) => {
    dispatch(webApiLoading());

    const token = getState().user.user.token;

    const res = await GetWebApiDocGlossaryById(token, version, id);

    if (res && res.data) {
      const data = res.data;

      dispatch({
        type: WEB_API_GET_RELATED_DOCS_BY_ID,
        payload: data,
      });

      return res;
    } else {
      dispatch({
        type: WEB_API_GET_RELATED_DOCS_BY_ID,
        payload: null,
      });

      return res;
    }
  };
};

export const getWebApiSectionByDocId = (version, id) => {
  return async (dispatch, getState) => {
    dispatch(webApiLoading());

    const token = getState().user.user.token;

    const res = await GetWebApiSectionByDocId(token, version, id);

    if (res && res.data) {
      const data = res.data;

      dispatch({
        type: WEB_API_GET_SECTION_BY_PAGE_ID,
        payload: data,
      });

      return res;
    } else {
      dispatch({
        type: WEB_API_GET_SECTION_BY_PAGE_ID,
        payload: null,
      });

      return res;
    }
  };
};

export const getWebApiGetRelatedSectionsId = (version, id) => {
  return async (dispatch, getState) => {
    dispatch(webApiLoading());

    const token = getState().user.user.token;

    const res = await GetWebApiGetRelatedSectionsId(token, version, id);

    if (res && res.data) {
      const data = res.data;

      dispatch({
        type: WEB_API_GET_RELATED_SECTION_BY_ID,
        payload: data,
      });

      return res;
    } else {
      dispatch({
        type: WEB_API_GET_RELATED_SECTION_BY_ID,
        payload: null,
      });

      return res;
    }
  };
};

export const getWebApiSummaryByDocId = (version, id) => {
  return async (dispatch, getState) => {
    dispatch(webApiLoading());

    const token = getState().user.user.token;

    const res = await GetWebApiSummaryByDocId(token, version, id);

    if (res && res.data) {
      const data = res.data;

      dispatch({
        type: WEB_API_GET_SUMMARY_BY_DOC_ID,
        payload: data,
      });

      return res;
    } else {
      dispatch({
        type: WEB_API_GET_SUMMARY_BY_DOC_ID,
        payload: null,
      });

      return res;
    }
  };
};
